<template>
  <div class="container agreement">
    <div class="header card">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>应用管理</el-breadcrumb-item>
        <el-breadcrumb-item>协议管理</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">协议列表</h2>
        </div>
        <div class="right">
          <el-button class="button"
                     type="primary"
                     @click="handleAgreementCreate">添加协议</el-button>
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form class="search-wrap"
               ref="searchForm"
               :inline="true"
               :model="query">
        <el-form-item label="协议名称"
                      prop="name">
          <el-input v-model="query.name"
                    placeholder="输入协议名称"></el-input>
        </el-form-item>
        <el-form-item label="协议编码"
                      prop="code">
          <el-input v-model="query.code"
                    placeholder="输入协议编码"></el-input>
        </el-form-item>
      </el-form>
      <div class="divider"></div>
      <div class="action-wrap">
        <el-button type="primary"
                   @click="handleSearch">搜索</el-button>
        <el-button @click="handleFormReset('searchForm')">重置</el-button>
      </div>
    </div>
    <div class="results card">
      <div class="values-header">
        <p class="title">查找结果</p>
      </div>
      <div class="values">
        <el-table class="table"
                  :data="results"
                  border
                  style="width: 100%">
          <el-table-column prop="id"
                           label="ID"
                           width="100"
                           align="center">
          </el-table-column>
          <el-table-column prop="name"
                           label="协议名称"
                           min-width="160">
          </el-table-column>
          <-column prop="code"
                   label="协议编码"
                   min-width="160">
            </el-table-column>
            <el-table-column label="状态"
                             width="120"
                             align="center">
              <template slot-scope="scope">
                <el-tag :type="scope.row.status == 1?'success':'danger'">{{scope.row.status == 1 ? '正常' : '下线'}}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作"
                             width="180"
                             align="center"
                             fixed="right">
              <template slot-scope="scope">
                <el-button size="mini"
                           type="text"
                           @click="handleToAgreementEdit(scope.row, scope.$index)">编辑</el-button>
                <el-button size="mini"
                           type="text"
                           @click="handleToPreview(scope.row, scope.$index)">H5预览</el-button>
                <el-button class="remove-text-button"
                           size="mini"
                           type="text"
                           @click="handleToAgreementRemove(scope.row, scope.$index)">删除</el-button>
              </template>
            </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { agreementList, agreementDestroy } from '@/api/operation'

export default {
  data() {
    return {
      query: {
        name: '',
        code: '',
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
      },
      pageTotal: 10,
      results: [],
    }
  },
  created() {
    this.parseQuery()
    this.fetchAgreementList()
  },
  methods: {
    // 协议列表请求
    fetchAgreementList() {
      agreementList(this.query).then((res) => {
        this.results = res.list || []
        this.pageTotal = res.count
      })
      this.syncQuery()
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchAgreementList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchAgreementList()
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, 'pageIndex', 1)
      this.fetchAgreementList()
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields()
      this.fetchAgreementList()
    },
    // 协议创建
    handleAgreementCreate() {
      this.$router.push(`/agreement/create`)
    },
    // 协议编辑
    handleToAgreementEdit(row) {
      this.$router.push(`/agreement/edit/${row.id}`)
    },
    // 协议预览
    handleToPreview(row) {
      if (location.host.includes('admin.kaoyanbox.com')) {
        window.open(`https://h5.kaoyanbox.com/agreement/${row.code}`)
      } else {
        window.open(`http://h5.kaoyanbox.net/agreement/${row.code}`)
      }
    },
    // 协议删除
    handleToAgreementRemove(row) {
      // 二次确认删除
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning',
      })
        .then(() => {
          agreementDestroy({ id: row.id }).then((res) => {
            this.$message.success(`删除成功`)
            this.fetchAgreementList()
          })
        })
        .catch(() => {})
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key]
      })
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(
        (key) => this.$route.query[key] != this.query[key]
      )
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, this.query),
        })
    },
  },
}
</script>

<style scoped lang="less">
.agreement {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
</style>
